// Please read https://developer.apple.com/documentation/security/password_autofill/enabling_password_autofill_on_an_html_input_element
// For more info
export const USERNAME = 'username';
export const PASSWORD = 'current-password';
export const EMAIL = 'email';
export const NEW_PASSWORD = 'new-password';
export const OFF = 'off';



// WEBPACK FOOTER //
// ./app/constants/autocompleteFields.js